export default "__VITE_ASSET__15556423__"